import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import guid from "../../store/helpers/guid";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(1) * 3,
    overflowX: "auto"
  },
  table: {
    minWidth: 600
  }
});

const LogTab = props => {
  const { classes, changes } = props;

  return (
    <>
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Operator </TableCell>
              <TableCell>Data wprowadzenia </TableCell>
              <TableCell>Rodzaj zmiany </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {changes.map(change => {
              return (
                <TableRow key={guid()}>
                  <TableCell>{change.operator}</TableCell>
                  <TableCell>
                    {moment.unix(change.czas).format("DD-MM-YYYY HH:mm")}
                  </TableCell>
                  <TableCell>{change.typ_zmian}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
};
export default withStyles(styles)(LogTab);
